module.exports = __webpack_public_path__ + "static/media/lb.b258cb0b.webp";